import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityRequestEntmt } from "../../entity/EntityRequestEntmt";

export class DtoRequestEntmtsGetRes extends EntityRequestEntmt {
  public items: EntityRequestEntmt[]  = [];
}
